<template>
    <div>
        <a-row :gutter="20">
            <a-col :span="6" class="gkbg">
                <div class="fxlist">

                    <h1 class="fxnum color1">{{ info.base_station_total }}<span>个</span></h1>
                    <h2 class="fxzi">总入网站点数</h2>

                </div>
            </a-col>
            <a-col :span="6" class="gkbg">
                <div class="fxlist">

                    <h1 class="fxnum color2">{{ info.online_total }}<span>天</span></h1>
                    <h2 class="fxzi">总在线天数</h2>


                </div>
            </a-col>
            <a-col :span="6" class="gkbg">
                <div class="fxlist">

                    <h1 class="fxnum color3">{{ info.peak_shaving_total }}<span>kw/h</span></h1>
                    <h2 class="fxzi">总调峰度数</h2>


                </div>
            </a-col>
            <a-col :span="6" class="gkbg">
                <div class="fxlist">

                    <h1 class="fxnum color4">{{ info.peak_shaving_power_rate_total }}<span>元</span></h1>
                    <h2 class="fxzi">总调峰电费</h2>


                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>



export default {
    name: 'GaiKuang',
    components: {

    },
    props: {
        info: Object
    },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.gkbg {}



.fxlist {
    display: flex;
    flex-flow: column;
    text-align: center;
    background: url('@/assets/gkbg2.png') bottom center;
    height: 170px;
    background-repeat: no-repeat;
}

.fxlist h1 {
    margin: 0;
    padding: 0;
    height: 70px;

}

.fxlist h2 {
    margin-top: 10px;
    margin-bottom: 30px;
}

.fxzi {

    color: #edeff2;
    font-size: 16px;
    padding: 0;
    margin: 0;
}

.fxnum {

    font-size: 60px;
    font-family: Arial, Helvetica, sans-serif;
    padding: 5px 0 0 0;
    margin: 0;
    letter-spacing: 1px;
}

.fxnum span {
    font-size: 18px;
    font-weight: bold;
}

.color1 {
    color: #2489ff;
}

.color2 {
    color: #2489ff;
}

.color3 {
    color: #2489ff;
}

.color4 {
    color: #2489ff;
}
</style>
